<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  利用料について</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">中古ピアノを探されているユーザーの方の利用料について</div>
                <div class="card-body">
                  <h2>登録・利用料は無料</h2>
                  <p>中古ピアノを探されているユーザーの方は、アカウント登録やサイト利用について、費用は一切かかりません。申し込みやお気に入り登録機能などを、すべて無料で使うことができます。</p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ChargeUser',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ChargeUser.vue